import rsvpSingleMessageModalCreator from '../../../../../modules/messages/helpers/rsvp-single-message-modal-creator';

/**
 * @ngdoc service
 * @name checkins.factory:emailContact
 *
 * @description
 *
 */


function emailRsvp($injector) {
    return {
        key: 'email-rsvp',
        title: 'Send Email',
        icon: 'envelope',
        level: 'highlight',
        order: 30,
        action(rsvp) {
            rsvpSingleMessageModalCreator($injector, rsvp, rsvp.contact.data, {
                guestlist: rsvp.guestlist.data
            });
        }
    }
}

angular
    .module('festzelt-os.guestlists')
    .factory('emailRsvp', [
        '$injector',
        emailRsvp
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/detailed/email-rsvp.js